import { render } from "./DepartmentSummaryHeader.vue?vue&type=template&id=7a79c9b7&scoped=true&ts=true"
import script from "./DepartmentSummaryHeader.vue?vue&type=script&lang=ts"
export * from "./DepartmentSummaryHeader.vue?vue&type=script&lang=ts"

import "./DepartmentSummaryHeader.vue?vue&type=style&index=0&id=7a79c9b7&lang=css"
import "./DepartmentSummaryHeader.vue?vue&type=style&index=1&id=7a79c9b7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a79c9b7"]])

export default __exports__